/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsContainers: {
  name: 'containers';
  data: string;
} = {
  name: 'containers',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 2a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2h1V3a1 1 0 0 1 2 0v1h10V3a1 1 0 0 1 1-1ZM4 8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H4Zm1 8v-4.08L7.914 16H5Zm4-1.92L6.086 10H9v4.08ZM14 8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-6Zm1 3.92V16h2.914L15 11.92Zm4 2.16V10h-2.914L19 14.08ZM3 21a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
